import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";
import { useStore } from "../../helpers";
import { useParams } from "react-router-dom";
import { BoothTreeView, FormButtons, TailwindModal } from "../../components";
import { useTranslation } from "react-i18next";
import { TaskSearch } from "./task-search";
import Select from "react-select";
import { safe_get } from "../../report-visuals";
import TaskSearchV2 from "./task-list-components/TaskSearchV2";

export const CreateTask = observer((props: any) => {
  const rootStore = useStore();
  const [t] = useTranslation("task_manager");
  const { taskManagerStore } = rootStore;
  const { task_add_modal, task_type } = taskManagerStore;
  const { projectid } = useParams();
  const [surveys, setSurveys] = useState([]);
  const [taskPayload, setTaskPayload] = useState({});

  useEffect(() => {
    const active_project = JSON.parse(localStorage.getItem("__active_project"));
    setSurveys(safe_get(active_project, "surveys", []));
  }, [projectid]);

  const fetch_task_list = async () => {
    await taskManagerStore.get_task_list(projectid);
  };

  const set_selected_booth = (booth) => {
    setTaskPayload({ ...taskPayload, node: booth });
  };

  const onSave = async (evt) => {
    const payload = {
      projectid: parseInt(projectid),
      surveyid: taskPayload["surveyid"],
      count: parseInt(taskPayload["count"]),
    };
    console.log(payload, "payload here")
    console.log(task_type, "task type")
    if (task_type === "single") {
      const res = await taskManagerStore.create_single_task({
        ...payload,
        node: taskPayload["node"],
      });
      if (res.ok) {
        toast.success("Task created successfully....");
        setTaskPayload({ ...taskPayload, count: "", node: {} });
      }
    }

    // if (task_type === "bulk") {

    // }
    const res = await taskManagerStore.create_bulk_tasks(payload);
    if (res.data) {
      toast.success("Tasks are created successfully....");
    }

    await fetch_task_list();
    taskManagerStore.set_task_add_modal(false);
  };

  return (
    <>
      <TailwindModal isOpen={task_add_modal}>
        <div className="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full border border-gray-200">
          <div className="p-6 border-b border-gray-200">
            <div className="text-xl font-bold text-gray-900">
              Create Task
            </div>
            <p className="text-sm text-gray-500 mt-1">Fill in the details to create a new task</p>
          </div>
          <div className="p-6">
            <label htmlFor="role" className="block text-sm font-semibold text-gray-700 mb-2">
              Select Survey
            </label>
            <Select
              name={"Select Survey"}
              options={surveys.map((survey) => {
                return {
                  label: survey.name,
                  value: survey.id,
                };
              })}
              onChange={(val, action) => {
                setTaskPayload({
                  ...taskPayload,
                  surveyid: val.value,
                });
              }}
              placeholder={"Select a survey..."}
              className="w-full h-auto rounded-lg z-999 focus:shadow outline-none basic-multi-select"
              classNamePrefix="select"
              required={true}
            />

            <div className="w-full mt-4">
              <label
                htmlFor={t("new_project")}
                className="block text-sm font-semibold text-gray-700 mb-2"
              >
                {t("surveys_per_booth")}
              </label>
              <input
                type="number"
                className="px-4 py-3 rounded-lg border border-gray-300 w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                placeholder="Enter number of surveys"
                value={taskPayload["count"]}
                onChange={(e) =>
                  setTaskPayload({ ...taskPayload, count: e.target.value })
                }
              />
            </div>

            {task_type === "single" && (
              <div className="flex flex-col mt-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Select Booth
                </label>
                <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
                  <BoothTreeView
                    onBoothSelection={set_selected_booth}
                    selected_booth={safe_get(taskPayload, "node", {})}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
            <FormButtons
              onSave={onSave}
              type={"button"}
              onCancel={() => {
                taskManagerStore.set_task_add_modal(false);
              }}
            />
          </div>
        </div>
      </TailwindModal>
    </>
  );
});
